import { atom } from 'jotai'

import type { INotification } from '../domain/interface'

export const notificationAtom = atom<INotification | null>(null)
